import React from "react";
import { ChevronUp } from "react-bootstrap-icons";
interface IAccountListItem {
  setAccsShown: React.Dispatch<React.SetStateAction<boolean>>; //для установки состояние видимости списка аккаунтов
  accountNum: string; //номер аакаунта
  accsShown: boolean; //показан ли список аккаунтов
  accountsCount: number; 
  addressOrOwnerFIO: string; //адрес
}

export const AccountsBlockTitle = ({
  setAccsShown,
  accountNum,
  accsShown,
  accountsCount,
  addressOrOwnerFIO
}: IAccountListItem) => {
  return (
    <div className="data-card__accs_main">
      <h2 className="data-card__title data-card__title_number">{accountNum}</h2>
      <p className="data-card__adress data-card__adress_active">{addressOrOwnerFIO}</p>
      {accountsCount > 1 && (
        <button
          className="data-card__arrow-button"
          onClick={() => setAccsShown(!accsShown)}
        >
          <ChevronUp
            style={{
              transform: "rotateX(" + (accsShown ? "0deg" : "-180deg") + ")",
            }}
          />
        </button>
      )}
    </div>
  );
};
